<template>
    <div>        
        <!-- 메인 컨텐츠 영역 -->
        <article class="main_contents padding_none">
            <div class="write_wrap">            
                <!-- 제목 -->
                <div class="form-group">
                    <input type="text" class="form-control" ref="title" title="제목" placeholder="제목" v-model="title" />
                </div>                
                <!-- 내용 -->
                <div class="form-group">
                    <textarea class="form-control" ref="contents" title="내용" placeholder="내용" v-model="contents"></textarea>
                </div>                
                <!-- 파일첨부 -->
                <div class="form-group">
                    <label class="btn_upload" for="fileupload" :disabled="file_list.length==3" title="파일 선택 버튼">파일 선택</label>                    
                    <input type="file" id="fileupload" class="input_hidden" @change="fileAttach" :disabled="file_list.length==3" />
                    <ul v-if="file_list.length>0">
                        <li v-for="(file, index) in file_list" :key="index"><div class="filelist">{{file.name}}</div><button class="btn_common btn_short" @click="fileDelete(file)">삭제</button></li>                        
                    </ul>
                </div>
            </div>
            <div class="btn_bottom padding_wrap">
                <button class="btn_common btn_twin" @click="writeAction">등록</button>
                <button class="btn_common btn_twin" @click="boardList">취소</button>
            </div>
        </article>
        <!--// 메인 컨텐츠 영역 -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            c_no: this.$route.params.c_no,
            title: "",
            contents: "",
            file_list: []
        }
    },    
    methods: {        
        boardList() {
            this.$router.push('/m/board/'+this.c_no);
        },
        fileAttach(e) {
            if(e.target.files) {
                var upload_file = e.target.files[0];

                if(upload_file.size >= this.CONSTANT.MAX_UPLOAD_FILE_SIZE) {
                    alert("업로드 파일은 5MB 이하만 첨부 가능합니다.");
                    return;
                }

                this.file_list.push(upload_file);
            }
        },
        fileDelete(file) {
            var files = [];

            for(var i=0; i<this.file_list.length; i++) {
                if(file.lastModified==this.file_list[i].lastModified && file.size==this.file_list[i].size) {
                    continue;
                }
                
                files.push(this.file_list[i]);
            }

            this.file_list = files;
        },
        writeAction() {
            if(this.title == "") {
                alert("제목을 입력해주세요.");
                this.$refs.title.focus();
                return;
            }

            if(this.contents == "") {
                alert("본문을 입력해주세요.");
                this.$refs.contents.focus();
                return;
            }

            var formData = new FormData();
            formData.append("c_no", this.c_no);
            formData.append("title", this.title);
            formData.append("contents", this.contents);

            for(var i=0; i<this.file_list.length; i++) {
                formData.append("file_"+i, this.file_list[i]);
            }

            this.$http.post('/api/board/registAction.do', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if(response.data.retval == this.CONSTANT.SUCCESS) {
                    this.$router.push("/m/board/view/"+this.c_no+"/"+response.data.b_c_no);
                } else {
                    if(response.data.retval == this.CONSTANT.LOGIN_ERROR) {
                        this.$store.commit("setSession", null);
                        this.$router.push({path: "/m/login", query: {return_url: "/m/board/write/"+this.c_no}});
                    } else {
                        alert("게시판 정보 조회를 실패하였습니다. [error_code:"+response.data.retval+"]");
                    }
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/board/Write.vue